import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b014999a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b014999a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b014999a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b014999a')) {
      api.createRecord('b014999a', component.options)
    } else {
      api.reload('b014999a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b014999a&scoped=true&", function () {
      api.rerender('b014999a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/rank/index.vue"
export default component.exports